import PropTypes from 'prop-types';

import * as utils from '../utils';

import DossierDocumentList from './DossierDocumentList';

function DossierList(props) {
  return (<>
    {utils.processDocuments(props.documents)
      .map(({dossier, documentsVersions}) => (
        <DossierDocumentList
          key={dossier}
          dossier={dossier}
          documentsVersions={documentsVersions}
          documentPermissions={props.documentPermissions}
          documentActions={props.documentActions}
          correlationIdOpened={props.correlationIdOpened}
          organisationId={props.organisationId}
          onClick={props.onClickDocument}
        />
      ))}
  </>);
}

DossierList.propTypes = {
  documents: PropTypes.array.isRequired,
  documentPermissions: PropTypes.object.isRequired,
  documentActions: PropTypes.object.isRequired,
  correlationIdOpened: PropTypes.string,
  organisationId: PropTypes.number.isRequired,
  onClickDocument: PropTypes.func.isRequired
};

export default DossierList;
